import { Suspense, lazy } from 'react';

import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { Routes, Route, Navigate } from 'react-router';

import { LoadingScreen } from '@/components';
import { RootLayout } from '@/layouts';
import { APP_ROUTES } from '@/router/routesEnum';

const LandingPage = lazy(() => import('@/layouts/RootLayout/LandingPage'));
const AiresMethodologyPage = lazy(
  () => import('@/layouts/RootLayout/AiresMethodologyPage'),
);
const ImproveLID = lazy(
  () => import('@/layouts/RootLayout/AiresMethodologyPage/ImproveLid'),
);
const Page404 = lazy(() => import('@/pages/Page404'));

export function Router() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<RootLayout />}>
          <Route index path={APP_ROUTES.ROOT} element={<LandingPage />} />
          <Route
            path={APP_ROUTES.AIRES_METODOLOGY}
            element={<AiresMethodologyPage />}
          >
            <Route
              index
              element={<Navigate to={APP_ROUTES.AIRES_IMPROVE_LID} replace />}
            />
            <Route
              path={APP_ROUTES.AIRES_IMPROVE_LID}
              element={<ImproveLID />}
            />
            {/* <Route path={APP_ROUTES.AIRES_LID_FORECAST} element={<></>} /> */}
          </Route>
          <Route
            index
            path={APP_ROUTES.LENDING_METODOLOGY}
            element={
              <Typography variant="h2">
                Lending Methodology page <Chip label="Soon" color="primary" />
              </Typography>
            }
          />
          <Route
            index
            path={APP_ROUTES.COMMUNITY_METODOLOGY}
            element={
              <Typography variant="h2">
                Community Methodology page <Chip label="Soon" color="primary" />
              </Typography>
            }
          />
        </Route>
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Suspense>
  );
}
